import { render, staticRenderFns } from "./OrganisationPanel.vue?vue&type=template&id=fce71e22&scoped=true&"
import script from "./OrganisationPanel.vue?vue&type=script&lang=js&"
export * from "./OrganisationPanel.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationPanel.vue?vue&type=style&index=0&id=fce71e22&prod&lang=scss&scoped=true&"
import style1 from "./OrganisationPanel.vue?vue&type=style&index=1&id=fce71e22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce71e22",
  null
  
)

export default component.exports